import { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { StatTile, ViewTitle } from '../../reusable'
import { Loading } from 'notiflix'
import { Report } from 'notiflix/build/notiflix-report-aio'
import { useNavigate } from 'react-router-dom'
import api from '../../../helpers/apiRequester'
import { ReEngagementSearchView } from '../subViews/unifiedSearchViews/reEngagementSearch'
import { SupportSearchView } from '../subViews/unifiedSearchViews/supportSearch'
export interface statsProps {
    isSupportSearch?: boolean
}
export const UnifiedSearchView = (props: statsProps) => {
    const { isSupportSearch } = props

    return isSupportSearch ? <SupportSearchView /> : <ReEngagementSearchView />
}
